module.exports = "<div class=\"loading-screen-wrapper\" *ngIf=\"loading\">\r\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n</div>"